module.exports = __webpack_public_path__ + "img/2.79f8e957.png";